// @ts-strict-ignore

import type { Configuration } from '@empathybroker/tsclient-play/dist/models/configuration'
import type { RoleEnum } from '../enums'

import { mapGetters } from 'vuex'
import { RestrictedValueEnum } from '../enums'

import { AUTH_CONSTS, CONFIG_CONSTS } from '../store'

export const RestrictedMixin = {
  computed: {
    ...mapGetters(AUTH_CONSTS.moduleName, {
      authTokenInfo: AUTH_CONSTS.getters.tokenInfo,
    }),
    ...mapGetters(CONFIG_CONSTS.moduleName, {
      instanceConfig: CONFIG_CONSTS.getters.currentInstance,
    }),
    userRoles(): RoleEnum[] {
      const { '*': globalRoles, [this.instanceConfig.id]: instanceRoles } =
        this.authTokenInfo.authorization.roles
      return [...new Set([...(globalRoles || []), ...(instanceRoles || [])])]
    },
  },
  methods: {
    getRestrictedValueFromObject(restricted: Record<string, string[]>): RestrictedValueEnum {
      if (!restricted.role?.length) {
        return RestrictedValueEnum.NONE
      }
      if (this.userRoles.some((role: RoleEnum) => restricted.role.includes(role))) {
        return RestrictedValueEnum.WRITE
      }
      return RestrictedValueEnum.READ
    },
    getRestrictedObjectFromValue(value: RestrictedValueEnum): Record<string, string[]> {
      return {
        [RestrictedValueEnum.NONE]: () => ({}),
        [RestrictedValueEnum.WRITE]: () => ({ role: [...this.userRoles] }),
      }[value]()
    },
    getReadOnlyIdsFromData(data: Array<Configuration>): string[] {
      return data.reduce((readOnlyIds: string[], item) => {
        if (this.getRestrictedValueFromObject(item.restricted) === RestrictedValueEnum.READ) {
          readOnlyIds.push(item.id)
        }
        return readOnlyIds
      }, [])
    },
    getRestrictedIcon(value: RestrictedValueEnum): string {
      const iconFn = {
        [RestrictedValueEnum.READ]: () => 'lock',
        default: () => undefined,
      }
      return (iconFn[value] || iconFn.default)()
    },
    getRestrictedTooltip(value: RestrictedValueEnum): string {
      const restrictedMessages = this.$epb.messages.crud.restricted
      const tooltipFn = {
        [RestrictedValueEnum.READ]: () => restrictedMessages[RestrictedValueEnum.READ],
        default: () => undefined,
      }
      return (tooltipFn[value] || tooltipFn.default)()
    },
  },
}
